module.exports = __webpack_public_path__ + "img/slphouse_main11.70759ef5.png";